import { render, staticRenderFns } from "./settingUpdate.vue?vue&type=template&id=b1336ef8&scoped=true"
import script from "./settingUpdate.vue?vue&type=script&lang=js"
export * from "./settingUpdate.vue?vue&type=script&lang=js"
import style0 from "./settingUpdate.vue?vue&type=style&index=0&id=b1336ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1336ef8",
  null
  
)

export default component.exports